module.exports = __webpack_public_path__ + "img/cart.a4f75c0f.svg";